<template>
  <StatusDialog
    :visible.sync="dialogVisible"
    type="warning"
    :width="500"
    @close="handleClose"
  >
    <h3 class="status-dialog__title">注销提醒</h3>
    <p class="status-dialog__desc">
      注销后所有数据将被清空，需重新注册，请确认是否注销？
    </p>

    <div class="account-cancel-dialog__field">
      <img
        class="account-cancel-dialog__icon"
        src="@/assets/images/login/yzm.png"
        alt=""
      />
      <el-input
        v-model="verifyCode"
        maxlength="10"
        placeholder="请输入验证码"
      />
      <span
        v-if="smsReady"
        class="account-cancel-dialog__sms-btn"
        @click="sendSmsCode"
      >
        获取验证码
      </span>
      <span v-else class="account-cancel-dialog__sms-btn is-disabled">
        重新发送({{ smsCountdown }})
      </span>
    </div>
    <p class="account-cancel-dialog__phone">手机号码：{{ maskedPhone }}</p>

    <div class="status-dialog__footer">
      <button
        type="button"
        class="status-dialog__btn account-cancel-dialog__btn--danger"
        :disabled="loading || !verifyCode.trim()"
        @click="confirmLogout"
      >
        确认注销
      </button>
    </div>
  </StatusDialog>
</template>

<script>
/** 账号注销确认弹窗：短信验证码 + 确认注销 */
export default {
  name: "AccountCancelDialog",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /** 注销成功后的跳转地址 */
    redirectUrl: {
      type: String,
      default: "/",
    },
  },

  data() {
    return {
      verifyCode: "",
      smsReady: true,
      smsCountdown: 60,
      smsTimer: null,
      loading: false,
    };
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },

    rawPhone() {
      const u = this.$store.state.usermsg || {};
      return String(u.phone || u.mobile || u.mob || "").trim();
    },

    maskedPhone() {
      const phone = this.rawPhone;
      if (/^1\d{10}$/.test(phone)) {
        return `${phone.slice(0, 3)}****${phone.slice(7)}`;
      }
      return phone;
    },
  },

  beforeDestroy() {
    this.clearSmsTimer();
  },

  methods: {
    resetForm() {
      this.verifyCode = "";
      this.loading = false;
      this.smsReady = true;
      this.smsCountdown = 60;
      this.clearSmsTimer();
    },

    handleClose() {
      if (this.loading) return;
      this.resetForm();
      this.$emit("close");
    },

    clearSmsTimer() {
      if (this.smsTimer) {
        clearInterval(this.smsTimer);
        this.smsTimer = null;
      }
    },

    startSmsCountdown() {
      this.smsReady = false;
      this.smsCountdown = 60;
      this.clearSmsTimer();
      this.smsTimer = setInterval(() => {
        this.smsCountdown -= 1;
        if (this.smsCountdown <= 0) {
          this.clearSmsTimer();
          this.smsReady = true;
          this.smsCountdown = 60;
        }
      }, 1000);
    },

    /** 获取注销短信验证码 */
    sendSmsCode() {
      if (!/^1[3456789]\d{9}$/.test(this.rawPhone)) {
        this.$message.error("手机号码无效");
        return;
      }
      this.$request
        .post("/cloud/user_account/send_del_code", {}, { rawResponse: true })
        .then((res) => {
          if (res.data.code === 200) {
            this.startSmsCountdown();
          } else {
            this.$message.error(res.data.message || "获取验证码失败");
          }
        });
    },

    confirmLogout() {
      if (this.loading) return;
      if (!this.verifyCode) {
        this.$message.error("请输入验证码");
        return;
      }
      this.loading = true;
      this.$request
        .post(
          "/cloud/user_account/del_customer",
          { verifyCode: this.verifyCode },
          { rawResponse: true }
        )
        .then((res) => {
          this.tokenInvalid(res);
          if (res.data.code === 200) {
            localStorage.removeItem("token");
            localStorage.removeItem("res");
            this.$emit("success");
            window.location.href = this.redirectUrl;
          } else {
            this.loading = false;
            this.$alert(res.data.message || "注销失败", {
              confirmButtonText: "确定",
              type: "error",
              center: true,
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.status-dialog__desc {
  margin-bottom: 30px;
  line-height: 1;
}
.account-cancel-dialog__field {
  position: relative;
  width: 100%;
  margin: 0 auto 8px;
  text-align: left;
}

.account-cancel-dialog__field >>> .el-input__inner {
  height: 44px;
  padding-left: 40px;
  padding-right: 100px;
  line-height: 44px;
  border-color: #e7eaee;
  border-radius: 4px;
}

.account-cancel-dialog__icon {
  position: absolute;
  top: 50%;
  left: 14px;
  z-index: 1;
  width: 14px;
  height: 17px;
  transform: translateY(-50%);
}

.account-cancel-dialog__sms-btn {
  position: absolute;
  top: 50%;
  right: 12px;
  font-size: 14px;
  color: #5b85ff;
  white-space: nowrap;
  cursor: pointer;
  transform: translateY(-50%);
}

.account-cancel-dialog__sms-btn.is-disabled {
  color: #4184e1;
  cursor: default;
}

.account-cancel-dialog__phone {
  width: 100%;
  margin: 0 auto 25px;
  margin-top: 20px;
  font-size: 14px;
  color: #525252;
  text-align: left;
  line-height: 1;
}

.account-cancel-dialog__btn--danger {
  color: #fff;
  background: #f23a3a;
}

.account-cancel-dialog__btn--danger:hover:not(:disabled) {
  background: #ff5a5f;
  opacity: 0.92;
}
</style>



// WEBPACK FOOTER //
// src/components/accountCancelDialog/AccountCancelDialog.vue